import { classes } from '@lc/libreact'
import type { ReactNode } from 'react'
import styles from './Grid.scss'

export function Grid({
	columns,
	children,
	innerClassName,
	maxColumns = 4,
}: {
	columns: number
	children: ReactNode
	innerClassName?: string
	maxColumns?: number
}) {
	return (
		<div
			className={classes(styles.list, innerClassName)}
			style={{
				gridTemplateColumns: `repeat(${Math.min(columns, maxColumns)}, minmax(0, 1fr))`,
			}}
		>
			{children}
		</div>
	)
}
